import * as propertyTypes from "../property_types.js"


export class UiSKendoDropDownList extends propertyTypes.AppDataSourceBaseComponentProps {

    private listWidthMetadata = new propertyTypes.CheckBoxProperty("listWidth", "List width");
    public listWidth: string;

    private optionLabelMetadata = new propertyTypes.TextProperty("optionLabel", "Option label");
    public optionLabel: string;

    private valueTemplateMetadata = new propertyTypes.TextProperty("valueTemplate", "Value template");
    public valueTemplate: string;

    private valueNullIfNotInDSMetadata = new propertyTypes.CheckBoxProperty("valueNullIfNotInDS", "Set value to null if not in datasource");
    public valueNullIfNotInDS: boolean;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.allMetadata = baseMetaData.concat([this.listWidthMetadata, this.optionLabelMetadata, this.valueTemplateMetadata, this.valueNullIfNotInDSMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}